"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[591],{

/***/ 72591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87344);
/* harmony import */ var highcharts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78840);
/* harmony import */ var highcharts__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(highcharts__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var highcharts_react_official__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75708);
/* harmony import */ var highcharts_react_official__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(highcharts_react_official__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var highcharts_modules_annotations__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75111);
/* harmony import */ var highcharts_modules_annotations__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(highcharts_modules_annotations__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82492);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var _colors__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71637);
/* harmony import */ var _components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(89802);
/* harmony import */ var _components_WidgetErrorBoundary__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46400);
/* harmony import */ var _components_WidgetSubcomponents__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69443);
/* harmony import */ var _components_ToggleSwitch__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71122);
/* harmony import */ var _components_TimeFrameIndicator__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(62925);













// Somehow resolves an error thrown by the annotation lib
if (true) {
    // Initialize highchats annotations module (only on browser, doesn't work on server)
    highcharts_modules_annotations__WEBPACK_IMPORTED_MODULE_3___default()((highcharts__WEBPACK_IMPORTED_MODULE_1___default()));
}
const baseOptions = {
    accessibility: {
        enabled: false
    },
    chart: {
        zooming: {
            type: "x",
            resetButton: {
                position: {
                    x: 0,
                    y: 10
                },
                theme: {
                    fill: _colors__WEBPACK_IMPORTED_MODULE_6__/* ["default"].slateus600 */ .Z.slateus600,
                    style: {
                        opacity: 0.8,
                        fontSize: "12",
                        fontFamily: "Inter",
                        fontWeight: "300",
                        color: _colors__WEBPACK_IMPORTED_MODULE_6__/* ["default"].white */ .Z.white,
                        textTransform: "lowercase",
                        border: "1px solid ".concat(_colors__WEBPACK_IMPORTED_MODULE_6__/* ["default"].slateus400 */ .Z.slateus400)
                    },
                    r: 4,
                    zIndex: 20,
                    states: {
                        hover: {
                            fill: "#343C56"
                        }
                    }
                }
            }
        },
        backgroundColor: "transparent",
        showAxes: false,
        marginRight: 84,
        marginLeft: 40,
        marginTop: 14
    },
    title: undefined,
    xAxis: {
        type: "datetime",
        lineWidth: 0,
        labels: {
            enabled: false,
            style: {
                color: _colors__WEBPACK_IMPORTED_MODULE_6__/* ["default"].slateus400 */ .Z.slateus400
            }
        },
        tickWidth: 0
    },
    yAxis: {
        endOnTick: false,
        gridLineWidth: 0,
        labels: {
            style: {
                color: _colors__WEBPACK_IMPORTED_MODULE_6__/* ["default"].slateus400 */ .Z.slateus400,
                fontFamily: "Roboto Mono",
                fontSize: "12px",
                fontWeight: "300"
            }
        },
        title: undefined
    },
    legend: {
        enabled: false
    },
    tooltip: {
        backgroundColor: "transparent",
        borderWidth: 0,
        shadow: false,
        useHTML: true
    },
    credits: {
        enabled: false
    },
    plotOptions: {
        series: {
            animation: {
                duration: 300
            },
            marker: {
                enabled: true,
                lineColor: "white",
                radius: 0.4,
                symbol: "circle"
            }
        }
    }
};
const makeBarrier = (barrier)=>{
    return {
        id: "barrier-plotline",
        color: _colors__WEBPACK_IMPORTED_MODULE_6__/* ["default"].slateus500 */ .Z.slateus500,
        width: 1,
        value: barrier,
        zIndex: 10,
        label: {
            x: 84,
            text: "".concat(barrier === null || barrier === void 0 ? void 0 : barrier.toFixed(2), " Gwei \uD83E\uDD87\uD83D\uDD0A"),
            useHTML: true,
            align: "right",
            formatter: ()=>{
                return '\n      <div class="flex justify-end" title="ultra sound barrier">\n        <img\n          class="w-[15px] h-[15px]"\n          src="/bat-own.svg"\n        />\n        <img\n          class="ml-1 w-[15px] h-[15px]"\n          src="/speaker-own.svg"\n        />\n        <img\n          class="ml-1 w-[15px] h-[15px]"\n          src="/barrier-own.svg"\n        />\n      </div>\n      <div class="flex text-sm">\n        <div class="font-light text-white font-roboto">\n          '.concat(barrier === null || barrier === void 0 ? void 0 : barrier.toFixed(1), '\n        </div>\n        <div class="ml-1 font-light font-roboto text-slateus-200">\n          Gwei\n        </div>\n      </div>\n    ');
            }
        }
    };
};
const getTooltipFormatter = (baseFeesMap, barrier)=>function() {
        const x = typeof this.x === "number" ? this.x : undefined;
        if (x === undefined || barrier === undefined) {
            return undefined;
        }
        const total = baseFeesMap[x];
        if (total === undefined) {
            return undefined;
        }
        const dt = new Date(x);
        const formattedDate = (0,date_fns__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(dt, "iii MMM dd yyyy");
        const formattedTime = (0,date_fns__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(dt, "HH:mm:ss 'UTC'x");
        const gradientCss = total > barrier ? "from-orange-400 to-yellow-300" : "from-cyan-300 to-indigo-500";
        return '\n      <div class="p-4 rounded-lg border-2 font-roboto bg-slateus-700 border-slateus-400">\n        <div class="text-right text-slateus-400">'.concat(formattedDate, '</div>\n        <div class="text-right text-slateus-400">').concat(formattedTime, '</div>\n        <div class="flex justify-end mt-2">\n          <div class="bg-gradient-to-r bg-clip-text text-transparent ').concat(gradientCss, '">\n            ').concat(total.toFixed(2), '\n          </div>\n          <div class="ml-1 font-roboto text-slateus-400">Gwei</div>\n        </div>\n      </div>\n    ');
    };
const BaseFeesWidget = (param)=>{
    let { barrier , baseFeesMap , baseFeesSeries , max , onClickTimeFrame , timeFrame , blobFees  } = param;
    const [hideBarrier, setHideBarrier] = (0,react__WEBPACK_IMPORTED_MODULE_5__.useState)(false);
    // Setting lang has to happen before any chart render.
    (0,react__WEBPACK_IMPORTED_MODULE_5__.useEffect)(()=>{
        if ((highcharts__WEBPACK_IMPORTED_MODULE_1___default())) {
            highcharts__WEBPACK_IMPORTED_MODULE_1___default().setOptions({
                lang: {
                    resetZoomTitle: undefined
                }
            });
        }
    }, []);
    const options = (0,react__WEBPACK_IMPORTED_MODULE_5__.useMemo)(()=>{
        const min = baseFeesSeries === null || baseFeesSeries === void 0 ? void 0 : baseFeesSeries.reduce((min, point)=>point[1] < min ? point[1] : min, 15);
        let dynamicMax;
        if (hideBarrier) {
            if (baseFeesSeries && baseFeesSeries.length > 0) {
                const maxInData = Math.max(...baseFeesSeries.map((point)=>point[1]));
                dynamicMax = Math.ceil(maxInData / 10) * 10;
            }
        // If no data, let highcharts decide. dynamicMax will be undefined.
        } else {
            dynamicMax = Math.max(max !== null && max !== void 0 ? max : 0, barrier !== null && barrier !== void 0 ? barrier : 0);
        }
        return lodash_merge__WEBPACK_IMPORTED_MODULE_4___default()({}, baseOptions, {
            yAxis: {
                id: "base-fees",
                min,
                max: dynamicMax,
                plotLines: barrier !== undefined && !hideBarrier ? [
                    makeBarrier(barrier)
                ] : []
            },
            series: [
                {
                    animation: false,
                    id: "base-fees-over-area",
                    type: "areaspline",
                    threshold: barrier,
                    data: baseFeesSeries,
                    color: _colors__WEBPACK_IMPORTED_MODULE_6__/* ["default"].orange400 */ .Z.orange400,
                    negativeColor: _colors__WEBPACK_IMPORTED_MODULE_6__/* ["default"].blue400 */ .Z.blue400,
                    lineWidth: 0,
                    states: {
                        hover: {
                            lineWidthPlus: 0
                        }
                    },
                    negativeFillColor: {
                        linearGradient: {
                            x1: 0,
                            y1: 0,
                            x2: 0,
                            y2: 1
                        },
                        stops: [
                            [
                                0.2,
                                "#5487F400"
                            ],
                            [
                                1,
                                "#00FFFB10"
                            ]
                        ]
                    },
                    fillColor: {
                        linearGradient: {
                            x1: 0,
                            y1: 1,
                            x2: 0,
                            y2: 0
                        },
                        stops: [
                            [
                                (barrier !== null && barrier !== void 0 ? barrier : 0) / (max !== null && max !== void 0 ? max : 1),
                                "#EDDB3610"
                            ],
                            [
                                1,
                                "#E7980050"
                            ]
                        ]
                    }
                }
            ],
            tooltip: {
                formatter: getTooltipFormatter(baseFeesMap, barrier)
            }
        });
    }, [
        max,
        barrier,
        baseFeesMap,
        baseFeesSeries,
        hideBarrier
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_WidgetErrorBoundary__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        title: blobFees ? "blob fees" : "base fees",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_WidgetSubcomponents__WEBPACK_IMPORTED_MODULE_9__/* .WidgetBackground */ .K, {
            className: "relative flex h-full min-h-[398px] w-full flex-col lg:h-0",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "pointer-events-none absolute top-0 right-0 bottom-0 left-0 overflow-hidden rounded-lg",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        // will-change-transform is critical for mobile performance of rendering the chart overlayed on this element.
                        className: "\n              absolute -top-40\n              -left-56 h-full\n              w-full\n              opacity-[0.25]\n              blur-[110px]\n              will-change-transform\n            ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "\n                absolute bottom-[3.0rem]\n                -right-[1.0rem] h-2/5 w-3/5\n                rounded-[35%]\n                bg-[#0037FA]\n              "
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-baseline justify-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            className: "flex min-h-[21px] items-center",
                            children: blobFees ? "blob fees" : "base fees"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TimeFrameIndicator__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            timeFrame: timeFrame,
                            onClickTimeFrame: onClickTimeFrame
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    // flex-grow fixes bug where highcharts doesn't take full width.
                    className: "\n            mt-4 flex h-full\n            w-full select-none\n            justify-center\n            overflow-hidden\n            [&>div]:flex-grow\n          ",
                    children: baseFeesSeries === undefined ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "flex h-[400px] items-center justify-center lg:h-full",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            color: "text-slateus-300",
                            children: "data not yet available"
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((highcharts_react_official__WEBPACK_IMPORTED_MODULE_2___default()), {
                        highcharts: (highcharts__WEBPACK_IMPORTED_MODULE_1___default()),
                        options: options
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "mt-2 flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex items-center gap-2",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ToggleSwitch__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                    checked: hideBarrier,
                                    onToggle: setHideBarrier
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                    color: "text-slateus-400",
                                    children: "hide barrier"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_TextsNext_LabelText__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            color: "text-slateus-400",
                            children: [
                                "live on ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    className: "text-slateus-200",
                                    children: "ultrasound.money"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (BaseFeesWidget);


/***/ })

}]);